/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetEmpresaActivaUsuarioDtoProps } from "api/DTOs/GetEmpresaActivaUsuarioDto"
import { GetAllEmpresasUsuarioDtoIPagedEnumerableProps } from "api/Schemas/GetAllEmpresasUsuarioDtoIPagedEnumerable"
import { useTranslation } from "react-i18next"

import * as ROUTES from "routes/RoutePaths"

export interface UserMenuInnovaTemplate {
  showMenu: boolean
  goTo: (path: string) => void
}

interface ListMenuItemSubmenu {
  key: string
  title?: $TSMigrationFixMe
  leftIcon?: $TSMigrationFixMe
  subMenu?: string
  action?: $TSMigrationFixMe
  rightIcon?: $TSMigrationFixMe
  className?: string
}

interface SubMenu {
  title?: $TSMigrationFixMe
  subMenuClassNameClosed?: string
  subMenuClassNameOpen?: string
  items?: ListMenuItemSubmenu[]
}

interface ListMenuItem {
  key: string
  title?: $TSMigrationFixMe
  className?: string
  classNameSubMenu?: string
  leftIcon?: $TSMigrationFixMe
  rightIcon?: $TSMigrationFixMe
  open?: boolean
  subMenu?: SubMenu
  action?: $TSMigrationFixMe
}

interface Section {
  key: string
  title?: $TSMigrationFixMe
  className?: string
  items?: ListMenuItem[]
}

interface ListMenuSection {
  section?: Section
}

export const USER_MENU_LIST = (
  goTo: $TSMigrationFixMe,
  pathname: string,
  isGestoriaEnabled: boolean,
  setShowModalAsesoria: $TSMigrationFixMe,
  setShowModalCierreContable: React.Dispatch<React.SetStateAction<boolean>>,
  asesoriaActiva?: string
): ListMenuSection[] => {
  const { t } = useTranslation()
  return [
    {
      section: {
        key: "sec_empresas",
        title: (
          <div className='tw-mt-5 tw-mb-2 tw-ml-6 tw-text-left tw-text-sm tw-font-bold tw-uppercase'>
            {t("menuUser.titleCompany")}
          </div>
        ),
        className: "tw-select-none tw-text-secondary tw-font-bold",
        items: [
          {
            key: "perfilEmpresa",
            title: (
              <div className='tw-h-fit'>
                {t("menuUser.company.titleCompany")}
              </div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.EMPRESA) &&
              !pathname.includes(ROUTES.EMPRESAS_GESTIONADAS)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-text-text tw-mx-3 rounded-md`,
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "briefcase"]}
              />
            ),
            rightIcon: "",
            action: () => {
              goTo(ROUTES.EMPRESA)
            },
          },
          {
            key: "gestionUsuario",
            title: (
              <div className='tw-h-fit'>
                {t("menuUser.company.titleUserGestion")}
              </div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.ADMROLES)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text rounded-md`,
            classNameSubMenu: "",
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "user-group"]}
              />
            ),
            action: () => {
              goTo(ROUTES.ADMROLES)
            },
          },
          {
            key: "flujoAprobaciones",
            title: (
              <div className='tw-h-fit'>
                {t("menuUser.company.titleFlujoAprove")}
              </div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.APPROVALS)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text rounded-md`,
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "ballot-check"]}
              />
            ),
            action: () => {
              goTo(ROUTES.APPROVALS)
            },
          },
          {
            key: "gestionCategorias",
            title: (
              <div className='tw-h-fit'>
                {t("menuUser.company.titleCategoryManagement")}
              </div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.COMPANY_CATEGORIES)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-text-text tw-mx-3`,
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "tags"]}
              />
            ),
            rightIcon: "",
            action: () => {
              goTo(ROUTES.COMPANY_CATEGORIES)
            },
          },
          ...(asesoriaActiva
            ? [
                {
                  key: "asesorias",
                  title: (
                    <div className='tw-h-fit'>
                      {t("menuUser.company.titleAsesoria")}
                    </div>
                  ),
                  className:
                    "tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md tw-bg-white hover:tw-bg-background tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-text-text tw-mx-3",
                  leftIcon: (
                    <FontAwesomeIcon
                      className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                      icon={["fal", "handshake"]}
                    />
                  ),
                  rightIcon: "",
                  action: () =>
                    setShowModalAsesoria((prev: $TSMigrationFixMe) => ({
                      ...prev,
                      showModalAsesoria: !prev.showModalAsesoria,
                    })),
                },
              ]
            : []),
          ...(isGestoriaEnabled
            ? [
                {
                  key: "empresasGestionadas",
                  title: (
                    <div className='tw-h-fit'>
                      {t("menuUser.company.titleCompanies")}
                    </div>
                  ),
                  className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
                    pathname.includes(ROUTES.EMPRESAS_GESTIONADAS)
                      ? "!tw-text-secondary"
                      : "tw-bg-white hover:tw-bg-background"
                  } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-text-text tw-mx-3`,
                  leftIcon: (
                    <FontAwesomeIcon
                      className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                      icon={["fal", "grid-2"]}
                    />
                  ),
                  rightIcon: "",
                  action: () => {
                    goTo(ROUTES.EMPRESAS_GESTIONADAS)
                  },
                },
              ]
            : []),
        ],
      },
    },
    {
      section: {
        key: "sec_contabilidad",
        title: (
          <div className='tw-mt-5 tw-mb-2 tw-ml-6 tw-text-left tw-text-sm tw-font-bold tw-uppercase'>
            {t("menuUser.titleAccount")}
          </div>
        ),
        className: "tw-select-none tw-text-secondary tw-font-bold tw-bg-white",
        items: [
          {
            key: "validations",
            title: (
              <div className='tw-h-fit'>{t("menuUser.account.titleImp")}</div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.TAXES)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text rounded-md`,
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "landmark"]}
              />
            ),
            action: () => {
              goTo(ROUTES.TAXES)
            },
          },
          {
            key: "cuentasContables",
            title: (
              <div className='tw-h-fit'>
                {t("menuUser.account.titleAcount")}
              </div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.CUENTAS_CONTABLES)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text rounded-md`,
            classNameSubMenu: "",
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "calculator"]}
              />
            ),
            action: () => {
              goTo(ROUTES.CUENTAS_CONTABLES)
            },
          },
          {
            key: "cierreContable",
            title: <div className='tw-h-fit'>{t("mayor.accountingClose")}</div>,
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-mdtw-bg-white hover:tw-bg-background tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text rounded-md`,
            classNameSubMenu: "",
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "lock"]}
              />
            ),
            action: () => {
              setShowModalCierreContable(true)
            },
          },
        ],
      },
    },
    {
      section: {
        key: "sec_usuario",
        title: (
          <div className='tw-text-secondary tw-mt-5 tw-mb-2 tw-ml-6 tw-text-left tw-text-sm tw-font-bold tw-uppercase'>
            {t("menuUser.titleUser")}
          </div>
        ),
        className:
          "w-select-none tw-h-auto tw-max-h-[272px] tw-overflow-auto tw-text-secondary tw-font-bold tw-bg-white scroll-snap-y-none",
        items: [
          {
            key: "misDatos",
            title: (
              <div className='tw-h-fit'>{t("menuUser.user.titleData")}</div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.PROFILE)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text rounded-md`,
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "user"]}
              />
            ),
            rightIcon: "",
            action: () => {
              goTo(ROUTES.PROFILE)
            },
          },
          {
            key: "misEmpresas",
            title: (
              <div className='tw-h-fit'>{t("menuUser.user.titleCompany")}</div>
            ),
            className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-text tw-font-normal tw-text-md ${
              pathname.includes(ROUTES.MIS_EMPRESAS)
                ? "!tw-text-secondary"
                : "tw-bg-white hover:tw-bg-background"
            } tw-pl-2.5 tw-py-auto tw-w-auto tw-h-10 tw-mx-3 tw-text-text tw-mb-5 rounded-md`,
            classNameSubMenu: "",
            leftIcon: (
              <FontAwesomeIcon
                className='tw-mr-3 tw-flex-none tw-w-5 tw-h-5 tw-py-auto'
                icon={["fal", "building"]}
              />
            ),
            action: () => {
              goTo(ROUTES.MIS_EMPRESAS)
            },
          },
        ],
      },
    },
  ]
}

export const USER_COMPANIES_LIST = (
  setEmpresaActiva: $TSMigrationFixMe,
  misEmpresas: GetAllEmpresasUsuarioDtoIPagedEnumerableProps["items"],
  empresaActivaId: GetEmpresaActivaUsuarioDtoProps["id"],
  asesoriaId?: string | null
): ListMenuSection[] => {
  const listItems = misEmpresas?.map((empresa: $TSMigrationFixMe) => ({
    key: "razonSocial",
    title: (
      <div className='tw-truncate tw-pr-4 tw-ml-2.5 tw-w-full tw-h-fit'>
        {empresa.razonSocial}
      </div>
    ),
    className: `tw-relative tw-flex tw-items-center tw-cursor-pointer tw-text-left tw-font-normal tw-text-md tw-pl-5 tw-py-auto tw-min-h-10 tw-ml-0.5 tw-text-text tw-rounded-md tw-bg-white ${
      empresaActivaId === empresa.id ? "" : "hover:tw-bg-background"
    }`,
    leftIcon: (
      <div className='tw-flex tw-my-2 tw-justify-center tw-items-center'>
        <Avatar
          size='small'
          className={`${
            empresaActivaId === empresa.id
              ? "!tw-bg-secondary"
              : "!tw-bg-primary"
          }`}
          logo={empresa.logoAsBase64}
          initials={empresa.razonSocial.slice(0, 2).toUpperCase()}
        />
      </div>
    ),
    rightIcon: (empresa?.id === empresaActivaId ||
      empresa?.id === asesoriaId) && (
      <FontAwesomeIcon
        icon={["fal", "check"]}
        className='sub-element__empresa-activa__check tw-pr-2 tw-text-secondary'
      />
    ),
    action: () => {
      if (empresaActivaId !== empresa.id) {
        sessionStorage.setItem("empresaActivaChanging", "true")
        setEmpresaActiva(empresa?.id)
      }
    },
  }))

  return [
    {
      section: {
        key: "sec_empresas",
        title: null,
        className:
          "tw-select-none tw-text-secondary tw-font-bold !tw-max-h-[272px] tw-overflow-auto",
        items: listItems,
      },
    },
  ]
}
